import { render, staticRenderFns } from "./GlassDamagesReparationsQuestion.vue?vue&type=template&id=a1c48058&scoped=true"
import script from "./GlassDamagesReparationsQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassDamagesReparationsQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassDamagesReparationsQuestion.vue?vue&type=style&index=0&id=a1c48058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c48058",
  null
  
)

export default component.exports